import React, { useState } from "react";
import axios from "axios";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Textarea } from "../ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../ui/dialog";
import { toast } from "sonner";
import { PACKAGING_TEMPLATES } from "./catalogTemplates";
import ProductPhotoUpload from "./ProductPhotoUpload";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const FIELDS = ["catalog_visible", "catalog_order", "catalog_headline", "catalog_indications", "catalog_application", "catalog_technical", "catalog_weight", "catalog_color"];

export const pickCatalogFields = (p) => ({
  catalog_visible: p.catalog_visible !== false, catalog_order: p.catalog_order || 0,
  catalog_headline: p.catalog_headline || "", catalog_indications: p.catalog_indications || "",
  catalog_application: p.catalog_application || "", catalog_technical: p.catalog_technical || "",
  catalog_weight: p.catalog_weight || "", catalog_color: p.catalog_color || "",
});

const Field = ({ label, children }) => (<div><label className="text-xs font-bold">{label}</label>{children}</div>);

export default function CatalogProductDialog({ companyId, product, onClose, onSaved }) {
  const [d, setD] = useState(() => pickCatalogFields(product));
  const set = (patch) => setD((x) => ({ ...x, ...patch }));

  const save = async () => {
    const body = Object.fromEntries(FIELDS.map((k) => [k, k === "catalog_order" ? parseInt(d[k]) || 0 : (d[k] === "" ? null : d[k])]));
    try {
      await axios.put(`${API}/companies/${companyId}/factory/products/${product.id}/catalog`, body);
      toast.success("Produto atualizado no catálogo");
      onSaved();
      onClose();
    } catch (e) { toast.error("Erro: " + (e.response?.data?.detail || "")); }
  };

  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-2xl max-h-[92vh] overflow-y-auto" data-testid="catalog-product-dialog">
        <DialogHeader><DialogTitle>Catálogo · {product.name}</DialogTitle></DialogHeader>
        <div className="space-y-3">
          <div className="flex items-center gap-2 flex-wrap bg-slate-50 border rounded p-2">
            <span className="text-xs font-bold">Usar texto da embalagem:</span>
            {Object.keys(PACKAGING_TEMPLATES).map((k) => (
              <Button key={k} size="sm" variant="outline" onClick={() => set(PACKAGING_TEMPLATES[k])} data-testid={`catalog-template-${k}`}>{k}</Button>
            ))}
          </div>
          <div className="border rounded p-2">
            <label className="text-xs font-bold block mb-1">Foto do produto</label>
            <ProductPhotoUpload companyId={companyId} product={product} onChanged={onSaved} />
          </div>
          <div className="grid grid-cols-2 gap-2">
            <Field label="Destaque (ex.: Uso interno)"><Input value={d.catalog_headline} onChange={(e) => set({ catalog_headline: e.target.value })} data-testid="catalog-headline" /></Field>
            <Field label="Embalagem / peso"><Input value={d.catalog_weight} onChange={(e) => set({ catalog_weight: e.target.value })} placeholder="Saco 20 kg" data-testid="catalog-weight" /></Field>
            <Field label="Cor do cartão (vazio = cor principal)">
              <div className="flex gap-1">
                <Input type="color" value={d.catalog_color || "#047857"} onChange={(e) => set({ catalog_color: e.target.value })} className="h-9 p-1 flex-1" data-testid="catalog-color" />
                <Button size="sm" variant="outline" onClick={() => set({ catalog_color: "" })} data-testid="catalog-color-reset">{d.catalog_color ? "Padrão" : "Usando padrão"}</Button>
              </div>
            </Field>
            <Field label="Ordem no catálogo"><Input type="number" value={d.catalog_order} onChange={(e) => set({ catalog_order: e.target.value })} data-testid="catalog-order" /></Field>
          </div>
          <Field label="Indicações"><Textarea rows={3} value={d.catalog_indications} onChange={(e) => set({ catalog_indications: e.target.value })} data-testid="catalog-indications" /></Field>
          <Field label="Modo de uso / Aplicação"><Textarea rows={4} value={d.catalog_application} onChange={(e) => set({ catalog_application: e.target.value })} data-testid="catalog-application" /></Field>
          <Field label="Dados técnicos"><Textarea rows={2} value={d.catalog_technical} onChange={(e) => set({ catalog_technical: e.target.value })} data-testid="catalog-technical" /></Field>
          <label className="flex items-center gap-2 text-sm cursor-pointer">
            <input type="checkbox" checked={d.catalog_visible} onChange={(e) => set({ catalog_visible: e.target.checked })} data-testid="catalog-visible" />
            Mostrar este produto no catálogo
          </label>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Cancelar</Button>
          <Button onClick={save} data-testid="catalog-product-save">Salvar</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
